import { LEVEL, usePermission } from '../../hooks/usePermission';
import { useIsPsiStaff } from '../../utils/psiStaff';
import { useGettingStarted } from '../../api/gettingStartedApi';
import { useGlobalStore } from '../../stores/globalStore';

/**
 * Who may use Getting Started: Dietech_Facility_Level 2 (the level that changes facility settings)
 * or PSI staff, as GettingStartedController checks. Others never ask the API, so the dashboard and
 * Setup page show them nothing.
 */
export function useGettingStartedAccess(): boolean {
  const { getLevel, roleLoaded } = usePermission();
  const psi = useIsPsiStaff();
  return roleLoaded && (psi || getLevel('dietech_Facility_Level') >= LEVEL.EDIT);
}

/**
 * Whether Getting Started is on for this facility: the API's master switch, and either PSI's test list or
 * Tech Log's open onboarding plan with "Show the Getting Started wizard" on. Auto setup on Tray Line Setup
 * and Check allergy protection (Tables > Food Allergies, /allergy-protection) show only then, so someone
 * new signing in to an existing facility never sees them. Asked for anyone with access to the facility
 * (the API sends only `enabled` to those below the wizard's level), through the wizard's own query, so
 * there is one answer and one request. `ask` = false asks nothing and answers off.
 */
export function useGettingStartedEnabled(ask = true): { enabled: boolean; loading: boolean } {
  const facilityId = useGlobalStore((s) => s.facilityId);
  const { data, isLoading } = useGettingStarted(facilityId, ask);
  return { enabled: ask && data?.enabled === true, loading: ask && facilityId > 0 && isLoading };
}
